<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>
<style>
	@import url("../common/style.css");
*{
	margin: 0;
	padding: 0;
	box-sizing: border-box;
}
img{
	display: block;
}
ul,li{
	list-style: none;
}
#app {
	background-color: #F0F2F5;
}
.cursor{
	cursor: pointer;
}
.mainW{
	width: 1200px;
	margin: 0 auto;
}
.mainW2{
	width: 1380px;
	margin: 0 auto;
}
.flex-space{
	display: flex;
	align-items: center;
	justify-content: space-between;
}
.flex-center{
	display: flex;
	align-items: center;
	justify-content: center;
}
.flex-start{
	display: flex;
	align-items: flex-start;
}
.flex-alitem{
	display: flex;
	align-items: center;
}
.mb-20{
	margin-bottom: 20px;
}
.release{
	position: fixed;
	display: inline-block;
	right: 30px;
	bottom: 15%;
	z-index: 2;

}
.release img{
	width: 200px;
}
.page{
	text-align: center;
	padding: 100px 0;
}
.line1{
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}
.line2{
	text-overflow: -o-ellipsis-lastline;
	overflow: hidden;
	text-overflow: ellipsis;
	display: -webkit-box;
	-webkit-line-clamp: 2;
	line-clamp: 2;
	-webkit-box-orient: vertical;
}
.line3{
	text-overflow: -o-ellipsis-lastline;
	overflow: hidden;
	text-overflow: ellipsis;
	display: -webkit-box;
	-webkit-line-clamp: 3;
	line-clamp: 3;
	-webkit-box-orient: vertical;
}

.ml-30{
	margin-left: 30px;
}
a{
	color: #333;
	text-decoration: none;
}
.loading {
  width: 50px;
  height: 50px;
  border: 2px solid #fff;
  border-top-color: transparent;
  border-radius: 100%;
  animation: circle infinite 0.75s linear;
}

/* 转转转动画 */
@keyframes circle {
  0% {
	transform: rotate(0);
  }
  100% {
	transform: rotate(360deg);
  }
}
.mt-noData{
	margin-top: 120px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue